import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Repeat } from 'lucide-react';
import { SERVICE_OPTIONS } from './inventoryUtils';

export const JobTypeEditor = ({ job, authFetch, onSaved }) => {
  const known = SERVICE_OPTIONS.some(([v]) => v === job.service);
  const [val, setVal] = useState(known ? job.service : '');
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await authFetch('patch', `/estimate/${job.id}/job-details`, { service: val });
      toast.success('Job type changed.');
      onSaved?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't change job type."); }
    finally { setSaving(false); }
  };
  return (
    <div className="rounded-md border border-slate-200 bg-white p-3 flex flex-wrap items-center gap-2" data-testid={`job-type-${job.ref}`}>
      <Repeat className="w-4 h-4 text-[color:var(--mv-orange)]" />
      <div className="text-[10px] font-black uppercase tracking-wider text-slate-500">Job type</div>
      <select value={val} onChange={(e) => setVal(e.target.value)} className="flex-1 min-w-[10rem] h-10 rounded-md border border-slate-200 px-2 text-sm bg-white" data-testid="job-type-select">
        {!known && <option value="">{job.service || 'Not set'} (current)</option>}
        {SERVICE_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <button type="button" onClick={save} disabled={saving || !val || val === job.service} className="h-10 px-4 rounded-md bg-[color:var(--mv-navy)] text-white text-sm font-bold inline-flex items-center gap-1.5 disabled:opacity-40" data-testid="job-type-save">
        {saving && <Loader2 className="w-4 h-4 animate-spin" />} Change
      </button>
    </div>
  );
};
